export const getLoadedPageCount = (loadedRowCount: number, pageSize: number): number => {
    if (pageSize <= 0) {
        return 1;
    }

    return Math.max(1, Math.ceil(loadedRowCount / pageSize));
};

export const getCurrentPageRows = <TRow>(
    rows: readonly TRow[], pageNumber: number, pageSize: number
): TRow[] => {
    if (pageSize <= 0) {
        return [];
    }

    const firstRowIndex = (pageNumber - 1) * pageSize;

    return rows.slice(firstRowIndex, firstRowIndex + pageSize);
};

export const getCurrentPageUsageGroupIds = <TRow extends {key: string;}>(
    rows: readonly TRow[]
): string[] => {
    return rows.map(
        row => row.key
    );
};

export const getContinuationAwareTotal = (
    loadedRowCount: number,
    currentPageNumber: number,
    pageSize: number,
    continuationToken:
        | string
        | null
        | undefined
): number => {
    if (pageSize <= 0) {
        return loadedRowCount;
    }

    const loadedPageCount = getLoadedPageCount(loadedRowCount, pageSize);

    const isAtOrBeyondLastLoadedPage = currentPageNumber >= loadedPageCount;

    const isLastPageFull = loadedRowCount > 0 && loadedRowCount % pageSize === 0;

    if (continuationToken && isAtOrBeyondLastLoadedPage && isLastPageFull
    ) {
        // One more row is expected to be loaded on the next page, so we add 1 to the total count.
        return (loadedPageCount * pageSize) + 1;
    }

    return loadedRowCount;
};